module.exports = __webpack_public_path__ + "media/application/images/svgs/carousel-chevron-left-88de63a19224627e5075c7cda4bc2fdd.svg";